
import config from "../config";
import axiosInstance, { axiosPublicInstance } from "../helpers/axiosInstance";
import { CryptoJSAesEncrypt, getDeviceId, AkdCrypt256b64 } from "../helpers/cryp";
import { deviceDetect, isDesktop, deviceType } from "react-device-detect";
const { osName } = deviceDetect();

const looksUrlSafeB64 = (s) => {
  if (typeof s !== "string" || s.length === 0) return false;
  if (!/^[A-Za-z0-9\-_]+={0,2}$/.test(s)) return false;
  try {
    let std = s.replace(/-/g, "+").replace(/_/g, "/");
    while (std.length % 4) std += "=";
    atob(std);
    return true;
  } catch { return false; }
};

export const doLogin = (data = {}) => {
  const staticData = {
    appCode: String(config().CODE),
    appVersion: String(config().VERSION ?? ""),
    deviceUuid: getDeviceId(),
    deviceName: osName || "Unknown",
    deviceType: isDesktop ? "PC" : deviceType,
    connectionCode: data.connectionCode ?? String(config().CONNECTION_CODE ?? "PARTNER"),
  };

  // --- ŞİFREYİ HAZIRLA ---
  const plainCandidate = data.passwordPlain ?? data.password ?? "";
  const isExplicitlyEncrypted = data.isEncrypted === true;

  let passwordForRequest;
  if (data.passwordPlain != null && String(data.passwordPlain).length > 0) {
    // açık şifre verildiyse her zaman Akd ile şifrele
    passwordForRequest = AkdCrypt256b64(String(data.passwordPlain));
  } else if (!isExplicitlyEncrypted && !looksUrlSafeB64(plainCandidate)) {
    // password alanı verildi ama şifreli görünmüyorsa şifrele
    passwordForRequest = AkdCrypt256b64(String(plainCandidate));
  } else {
   
    passwordForRequest = String(plainCandidate);
  }

  const postData = {
    login: data.login,
    password: passwordForRequest,
    appCode: staticData.appCode,
    appVersion: staticData.appVersion,
    deviceUuid: staticData.deviceUuid,
    deviceName: staticData.deviceName,
    deviceType: staticData.deviceType,
    connectionCode: staticData.connectionCode,
  };

  const signatureString =
    (postData.login ?? "") +
    (postData.password ?? "") +
    (postData.appCode ?? "") +
    (postData.appVersion ?? "") +
    (postData.deviceUuid ?? "") +
    (postData.deviceName ?? "") +
    (postData.deviceType ?? "") +
    (postData.connectionCode ?? "");

  const SIGNATURE = CryptoJSAesEncrypt(signatureString);

  console.log("doLogin postData:", { ...postData, password: "***" });
  console.log("doLogin SIGNATURE(len/peek):", SIGNATURE?.length, (SIGNATURE || "").slice(0, 10) + "...");

  return axiosInstance.post("/Membership/login/v2", postData, {
    headers: { signature: SIGNATURE, SIGNATURE: SIGNATURE, consumer: "apidoc" },
  });
};

export const getUserProfile = () => {
  return axiosInstance.get("/Membership/userProfile");
};

export const doLogout = () => {
  return axiosInstance.post("/Membership/logout");
};

export const changePassword = (data) => {
  return axiosInstance.put("/Membership/changePassword", data);
};

export const forgetPassword = (data) => {
  const staticData = { appCode: config().CONNECTION_CODE };
  const postData = { ...data, ...staticData };
  const signatureString = postData.email + postData.appCode;
  const SIGNATURE = CryptoJSAesEncrypt(signatureString);

  return axiosInstance.post("/Membership/renewPasswordMail", postData, {
    headers: { SIGNATURE },
  });
};

export const editProfile = () => {
  return axiosInstance.get("/Admin/user");
};

// renewToken sadece axiosPublicInstance ile çağrılacak
export const renewToken = (data) => {
  const staticData = { appCode: config().CONNECTION_CODE };
  const postData = { ...data, ...staticData };
  const signatureString = postData.oldJwt + postData.appCode;
  const SIGNATURE = CryptoJSAesEncrypt(signatureString);

  return axiosPublicInstance.post("/Membership/renewToken", postData, {
    headers: { SIGNATURE },
  });
};

const AuthService = {
  doLogin,
  getUserProfile,
  forgetPassword,
  changePassword,
  editProfile,
  doLogout,
  renewToken,
};

export default AuthService;
